import { Box } from '@chakra-ui/react'
import { Navigate, useParams } from 'react-router-dom'
import SpecialtyWorkspace from '../../components/Lab/SpecialtyWorkspace'
import RadiologyWorkspace from '../../components/Lab/RadiologyWorkspace'
import ParasitologyWorkspace from '../../components/Lab/ParasitologyWorkspace'
import BlotAnalysisWorkspace from '../../components/Lab/BlotAnalysisWorkspace'
import { LAB_APPS } from '../../config/labApps'
import { useLabAppAccess } from '../../hooks/useLabAppAccess'

export default function SpecialtyAnalysisPage() {
  const { specialtyId, caseId } = useParams<{ specialtyId: string; caseId?: string }>()
  const { isAppEnabled } = useLabAppAccess()

  // Le verrou de l'interrupteur admin : masquer les cartes et les raccourcis
  // ne suffit pas, l'adresse tapée à la main ouvrirait encore l'atelier. Une
  // application du catalogue fermée à cet utilisateur renvoie au Lab Studio.
  // Les ateliers hors catalogue (radiology…) ne sont pas concernés.
  if (specialtyId && LAB_APPS.some((a) => a.id === specialtyId) && !isAppEnabled(specialtyId)) {
    return <Navigate to="/lab" replace />
  }

  const renderWorkspace = () => {
    switch (specialtyId) {
      case 'radiology':
      case 'dicom-viewer':
        return <RadiologyWorkspace />
      case 'parasitology':
        return <ParasitologyWorkspace caseId={caseId} />
      case 'blot-analysis':
        return <BlotAnalysisWorkspace caseId={caseId} />
      // PROTIS partage l'atelier d'IRIS et n'en change que le catalogue : même
      // dépôt, même galerie, même export, mêmes cas. Un second atelier aurait
      // dupliqué 24 000 lignes pour une liste de tuiles.
      case 'protis':
        return <BlotAnalysisWorkspace caseId={caseId} module="protis" />
      default:
        return <SpecialtyWorkspace specialtyId={specialtyId || ''} />
    }
  }

  return (
    <Box
      p={{
        base: '16px',
        lg: '32px 50px',
        xl: '32px 100px',
      }}
      h={'100vh'}
      overflow="hidden"
    >
      {renderWorkspace()}
    </Box>
  )
}
